import { render, staticRenderFns } from "./CallRecordingModal.vue?vue&type=template&id=a96fa85a&"
import script from "./CallRecordingModal.vue?vue&type=script&lang=js&"
export * from "./CallRecordingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports